import React from 'react';
import { Box, Typography, Checkbox, IconButton, List, ListItem, ListItemText, ListItemIcon } from '@mui/material';
import { styled } from '@mui/material/styles';
import { MoreHorizontal, Globe } from 'react-feather';

const ListContainer = styled(Box)(({ theme }) => ({
    marginTop: '20px',
}));

const ListHeader = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: '8px 16px',
    borderBottom: '1px solid #e2e8f0',
    backgroundColor: '#f8fafc',
    borderRadius: '8px 8px 0 0',
}));

const StyledListItem = styled(ListItem)(({ theme }) => ({
    borderBottom: '1px solid #f1f5f9',
    '&:hover': {
        backgroundColor: '#f8fafc',
    },
}));

const LinkText = styled(Typography)(({ theme }) => ({
    fontSize: '14px',
    color: '#334155',
    fontWeight: 500,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
}));

const Badge = styled(Box)(({ theme }) => ({
    backgroundColor: '#dcfce7',
    color: '#166534',
    fontSize: '11px',
    fontWeight: 600,
    padding: '2px 8px',
    borderRadius: '12px',
    marginLeft: '8px',
}));

function SourceList({ links, selectedLinks, onToggle, onToggleAll }) {
    if (links.length === 0) {
        return (
            <Box sx={{ textAlign: 'center', py: 8, color: '#94a3b8' }}>
                <Globe size={48} style={{ marginBottom: 16, opacity: 0.5 }} />
                <Typography>Enter a URL above to scan for links</Typography>
            </Box>
        );
    }

    const allSelected = links.length > 0 && selectedLinks.size === links.length;

    return (
        <ListContainer>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#1e293b' }}>
                    Link sources
                </Typography>
            </Box>

            <ListHeader>
                <Checkbox
                    checked={allSelected}
                    indeterminate={selectedLinks.size > 0 && selectedLinks.size < links.length}
                    onChange={onToggleAll}
                    size="small"
                />
                <Typography variant="body2" sx={{ ml: 1, fontWeight: 500, color: '#64748b' }}>
                    Select all
                </Typography>
            </ListHeader>

            <List sx={{
                maxHeight: '400px',
                overflow: 'auto',
                border: '1px solid #e2e8f0',
                borderTop: 'none',
                borderRadius: '0 0 8px 8px'
            }}>
                {links.map((link, index) => (
                    <StyledListItem key={index} secondaryAction={
                        <IconButton edge="end" size="small">
                            <MoreHorizontal size={16} />
                        </IconButton>
                    }>
                        <ListItemIcon sx={{ minWidth: '40px' }}>
                            <Checkbox
                                edge="start"
                                checked={selectedLinks.has(link)}
                                onChange={() => onToggle(link)}
                                size="small"
                            />
                        </ListItemIcon>
                        <ListItemText
                            primary={
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <LinkText>{link}</LinkText>
                                    <Badge>New</Badge>
                                </Box>
                            }
                        />
                    </StyledListItem>
                ))}
            </List>
        </ListContainer>
    );
}

export default SourceList;
